/* eslint-disable */
import React from 'react';
import { Box, MenuItem, Pagination as MuiPagination, Select, Typography } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const TablePagination = ({ page = 1, pageSize = 10, total = 0, onChange, pageSizeOptions, onPageSizeChange, sx = {} }) => {
  const totalPages = Math.ceil(total / pageSize);
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '20px',
        py: '8px',
        backgroundColor: '#F8FAFC',
        flexWrap: 'wrap',
        gap: '10px',
        ...sx,
      }}
    >
      {/* Left: lines per page + count */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        {pageSizeOptions && onPageSizeChange && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
            <Typography sx={{ fontSize: '12px', color: '#8F8F8F', fontFamily: "'Open Sans', sans-serif", whiteSpace: 'nowrap' }}>
              Nombre de lignes par page
            </Typography>
            <Select
              size="small"
              value={pageSize}
              onChange={(e) => onPageSizeChange(Number(e.target.value))}
              IconComponent={KeyboardArrowDownIcon}
              sx={{
                fontSize: '12px', color: '#385576', fontWeight: 700,
                height: '26px',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 20px 80px #00000011',
                borderRadius: '8px',
                '& .MuiSelect-select': { pl: '6px !important', pr: '28px !important' },
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
                '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
              }}
            >
              {pageSizeOptions.map((opt) => (
                <MenuItem key={opt} value={opt} sx={{ fontSize: '12px' }}>{opt}</MenuItem>
              ))}
            </Select>
          </Box>
        )}
        <Typography sx={{ fontSize: '12px', color: '#8F8F8F', fontFamily: "'Open Sans', sans-serif" }}>
          {total === 0 ? 'Aucun résultat' : `Affichage de ${from} à ${to} sur ${total} résultats`}
        </Typography>
      </Box>

      {/* Right: MUI pagination */}
      {totalPages > 1 && (
        <MuiPagination
          count={totalPages}
          page={page}
          onChange={(_, val) => onChange && onChange(val)}
          size="small"
          shape="rounded"
          siblingCount={1}
          boundaryCount={0}
          sx={{
            '& .MuiPagination-ul': {
              flexWrap: 'nowrap',
              alignItems: 'center',
              gap: '0px',
            },
            '& .MuiPaginationItem-root': {
              fontSize: '13px',
              color: '#4D4D4D',
              borderRadius: '6px',
              border: 'none',
              minWidth: '32px',
              height: '32px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 2px',
            },
            '& .MuiPaginationItem-root.Mui-selected': {
              backgroundColor: '#007BC6',
              color: '#fff',
              border: 'none',
              '&:hover': { backgroundColor: '#005F9E' },
            },
            '& .MuiPaginationItem-ellipsis': { border: 'none' },
            '& .MuiPaginationItem-previousNext': { border: 'none' },
          }}
        />
      )}
    </Box>
  );
};

export default TablePagination;